import { CustomerType } from "@origin-digital/platform-enums";
import {
  IMcAppType,
  NavFlow,
  salesCommonParameters,
  Tab,
} from "../mcApp.types";

export const addPlanFocused: IMcAppType = {
  name: "addPlanFocused",
  path: "/my/auth-add-plan",
  description: "This is the landing page for Authenticated Add plan",
  navFlow: NavFlow.FOCUS,
  title: "Add Plan",
  parent: Tab.DASHBOARD, // Changed from Tab.MORE, Temporary workaround due to navigation issues on Mobile. See https://origindd.atlassian.net/browse/P21-2410
  conditions: {
    intent: "addPlanFocused",
    customerType: CustomerType.kraken,
  },
};

// new sales form auth addPlan navigation
export const salesFormAuthAddPlan: IMcAppType = {
  name: "salesFormAuthAddPlan",
  path: "/my/add-plan",
  parameters: {
    properties: {
      journeyType: salesCommonParameters.journeyType,
      originAddressId: salesCommonParameters.originAddressId,
      useCart: salesCommonParameters.useCart,
    },
    required: ["journeyType", "originAddressId"],
  },
  description: "(Internal) resi auth add plan entry into the sales form",
  navFlow: NavFlow.MODAL,
  title: "Add Plan",
  parent: Tab.DASHBOARD, // Changed from Tab.MORE, Temporary workaround due to navigation issues on Mobile. See https://origindd.atlassian.net/browse/P21-2410

  conditions: {
    intent: "salesFormAuthAddPlan",
    customerType: CustomerType.kraken,
  },
};

export const salesFormSmeAuthAddPlan: IMcAppType = {
  name: "salesFormSmeAuthAddPlan",
  path: "/my/business/add-plan",
  parameters: {
    properties: {
      journeyType: salesCommonParameters.journeyType,
      originAddressId: salesCommonParameters.originAddressId,
      useCart: salesCommonParameters.useCart,
    },
    required: ["journeyType", "originAddressId"],
  },
  description: "(Internal) SME auth add Plan entry into the sales form",
  navFlow: NavFlow.MODAL,
  title: "Add Plan",
  parent: Tab.DASHBOARD, // Changed from Tab.MORE, Temporary workaround due to navigation issues on Mobile. See https://origindd.atlassian.net/browse/P21-2410

  conditions: {
    intent: "salesFormSmeAuthAddPlan",
    customerType: CustomerType.kraken,
  },
};
